import { Database } from './types/supabase';

export interface Devotion {
  id: number;
  title: string;
  authorQuote: {
    text: string;
    author: string;
  };
  theme: string;
  description: string;
  verse: string;
  parable: {
    title: string;
    content: string;
  };
  reflection: string[];
  actionSteps: string[];
  prayer: string;
  completed?: boolean;
  section: DevotionSection;
  day: number;
  personalNote?: string;
}

export type EventType = 
  | 'convention'
  | 'church'
  | 'home group'
  | 'prayer meeting'
  | 'business'
  | 'family'
  | 'other';

export const EVENT_TYPES: EventType[] = [
  'convention',
  'church',
  'home group',
  'prayer meeting',
  'business',
  'family',
  'other'
];

export interface Event {
  id: string;
  user_id: string;
  title: string;
  description: string;
  date: string;
  is_private: boolean;
  venue?: string;
  venue_lat?: number;
  venue_lng?: number;
  created_at: string;
  updated_at: string;
  event_type: EventType;
}

export interface Sermon {
  id: string;
  devotion_id: number;
  title: string;
  author: string;
  content: string;
  song_url?: string;
  created_at: string;
  updated_at: string;
}

export interface YouthTeaching {
  id: string;
  devotion_id: number;
  title: string;
  author: string;
  content: string;
  song_url?: string;
  created_at: string;
  updated_at: string;
}

export interface UserProgress {
  id: string;
  user_id: string;
  start_date: string;
  current_devotion: number;
  completed_devotions: number[];
  created_at: string;
  updated_at: string;
}

export type DevotionSection = 
  | "Faith for Divine Fulfilled Expectations"
  | "Personal Relationship with God"
  | "The Abrahamic Way"
  | "Church Building and Service"
  | "Divine Achievements";

export const DEVOTION_SECTIONS: DevotionSection[] = [
  "Faith for Divine Fulfilled Expectations",
  "Personal Relationship with God",
  "The Abrahamic Way",
  "Church Building and Service",
  "Divine Achievements"
];